import {
  LIST_AUTOCOMPLETE_TEXT_REQUEST,
  LIST_AUTOCOMPLETE_TEXT_SUCCESS,
  LIST_AUTOCOMPLETE_TEXT_FAILURE,
  LIST_AUTOCOMPLETE_TEXT_SUMMARY_REQUEST,
  LIST_AUTOCOMPLETE_TEXT_SUMMARY_SUCCESS,
  LIST_AUTOCOMPLETE_TEXT_SUMMARY_FAILURE,
  CREATE_AUTOCOMPLETE_TEXT_REQUEST,
  CREATE_AUTOCOMPLETE_TEXT_SUCCESS,
  CREATE_AUTOCOMPLETE_TEXT_FAILURE,
  DETAIL_AUTOCOMPLETE_TEXT_REQUEST,
  DETAIL_AUTOCOMPLETE_TEXT_SUCCESS,
  DETAIL_AUTOCOMPLETE_TEXT_FAILURE,
  UPDATE_AUTOCOMPLETE_TEXT_REQUEST,
  UPDATE_AUTOCOMPLETE_TEXT_SUCCESS,
  UPDATE_AUTOCOMPLETE_TEXT_FAILURE,
  DELETE_AUTOCOMPLETE_TEXT_REQUEST,
  DELETE_AUTOCOMPLETE_TEXT_SUCCESS,
  DELETE_AUTOCOMPLETE_TEXT_FAILURE
} from '../../constants/autocomplete-texts'

const initialState = {
  loading: false,
  autoCompleteTexts: [],
  autoCompleteText: {},
  autoCompleteTextSummary:[],
  error: null,
  pageable: {}
}

const autoCompleteTextReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_AUTOCOMPLETE_TEXT_REQUEST:
      return {
        ...state,
        loading: true,
        autoCompleteTexts: []
      }
    case LIST_AUTOCOMPLETE_TEXT_SUCCESS:
      return {
        ...state,
        loading: false,
        autoCompleteTexts: action.payload,
        pageable: action.pageable
      }
    case LIST_AUTOCOMPLETE_TEXT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case LIST_AUTOCOMPLETE_TEXT_SUMMARY_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_AUTOCOMPLETE_TEXT_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        autoCompleteTextSummary: action.payload
      }
    case LIST_AUTOCOMPLETE_TEXT_SUMMARY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case CREATE_AUTOCOMPLETE_TEXT_REQUEST:
      return {
        ...state,
        loadingCreate: true
      }
    case CREATE_AUTOCOMPLETE_TEXT_SUCCESS:
      return {
        ...state,
        loadingCreate: false
      }
    case CREATE_AUTOCOMPLETE_TEXT_FAILURE:
      return {
        ...state,
        loadingCreate: false,
        error: action.payload
      }
    case DETAIL_AUTOCOMPLETE_TEXT_REQUEST:
      return {
        ...state,
        loadingDetail: true
      }
    case DETAIL_AUTOCOMPLETE_TEXT_SUCCESS:
      return {
        ...state,
        loadingDetail: false,
        autoCompleteText: action.payload
      }
    case DETAIL_AUTOCOMPLETE_TEXT_FAILURE:
      return {
        ...state,
        loadingDetail: false,
        error: action.payload
      }
    case UPDATE_AUTOCOMPLETE_TEXT_REQUEST:
      return {
        ...state,
        loadingUpdate: true
      }
    case UPDATE_AUTOCOMPLETE_TEXT_SUCCESS:
      const autoCompleteTextPayloadUpdate = action.payload
      const autoCompleteTextIdUpdate = action.autoCompleteTextId

      const autoCompleteTextsUpdate = [...state.autoCompleteTexts]
      const autoCompleteTextIndexUpdate = autoCompleteTextsUpdate.findIndex(autoCompleteText => autoCompleteText.id === autoCompleteTextIdUpdate)
      autoCompleteTextsUpdate[autoCompleteTextIndexUpdate] = autoCompleteTextPayloadUpdate

      return {
        ...state,
        loadingUpdate: false,
        autoCompleteTexts: autoCompleteTextsUpdate
      }
    case UPDATE_AUTOCOMPLETE_TEXT_FAILURE:
      return {
        ...state,
        loadingUpdate: false,
        error: action.payload
      }
    case DELETE_AUTOCOMPLETE_TEXT_REQUEST:
      return {
        ...state,
        loadingDelete: true
      }
    case DELETE_AUTOCOMPLETE_TEXT_SUCCESS:
      const autoCompleteTextIdDelete = action.payload
      const autoCompleteTextsDelete = [...state.autoCompleteTexts]
      const autoCompleteTextIndexDelete = autoCompleteTextsDelete.findIndex(autoCompleteText => autoCompleteText.id === autoCompleteTextIdDelete)
      autoCompleteTextsDelete.splice(autoCompleteTextIndexDelete, 1)

      return {
        ...state,
        loadingDelete: false,
        autoCompleteTexts: autoCompleteTextsDelete
      }
    case DELETE_AUTOCOMPLETE_TEXT_FAILURE:
      return {
        ...state,
        loadingDelete: false,
        error: action.payload
      }
    default:
      return state
  }
}

export default autoCompleteTextReducer